// extracted by mini-css-extract-plugin
module.exports = {"eventLayoutHover":"EventLayoutHover_eventLayoutHover__2uuR7","tagsAddButton":"EventLayoutHover_tagsAddButton__2dHlU"};